import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loadingState: false,
  loadingMessage:null,
};

const loaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    setLoader: (state, action) => {
      state.loadingState = action.payload;
    },
    setLoaderMessage: (state ,action)=>{
      state.loadingMessage=action.payload
    }
  },
});
export const { setLoader,setLoaderMessage } = loaderSlice.actions;
export default loaderSlice.reducer;